import { forwardRef } from 'react';
import type { ImageValue } from '@elfsight/configurator-contracts';
import { MediaImage, type MediaImageProps } from '@elfsight/widget-media';

export type BaseImageBlockProps = Omit<MediaImageProps, 'src'> & {
  src?: ImageValue;
  scale?: number;
};

function removeExtension(value: string = '') {
  return value.replace(/\.[^.]+$/, '');
}

export const BaseImageBlock = forwardRef<HTMLDivElement, BaseImageBlockProps>(
  (
    {
      className,
      style,
      src,
      alt,
      scale = 100,
      ratio,
      borderRadius,
      containerHeight,
      onClick
    },
    forwardingRef
  ) => {
    const imageName = removeExtension(src?.name || src?.url.split('/').pop());

    return (
      <MediaImage
        ref={forwardingRef}
        className={className}
        style={style}
        src={src?.url}
        alt={alt || imageName}
        containerWidth={`${scale}%`}
        containerHeight={containerHeight}
        ratio={ratio}
        borderRadius={borderRadius}
        onClick={onClick}
      />
    );
  }
);
